import {
  CheckCircleIcon,
  ExclamationCircle,
  CopyShapeIcon,
} from '@trufla-technology/trumarket-react-design-system';

interface IProps {
  environment?: string;
  user?: string;
  password?: string;
  baseUrl?: string;
  envFtpVerified?: {
    verified?: boolean;
    message?: string;
  };
  isLoading?: boolean;
}

function Credential({
  environment,
  user,
  password,
  baseUrl,
  envFtpVerified,
  isLoading,
}: IProps) {
  return (
    <div className="environment-details">
      <div className="environment-wrapper">
        <h2 className="environment-name">{environment}</h2>
        <div className={`environment-card`}>
          <div
            className={`environment-content ${
              envFtpVerified && !envFtpVerified?.verified && !isLoading
                ? 'env-error-border'
                : ''
            } ${isLoading && 'env-pending-border'}`}
          >
            {envFtpVerified?.verified && (
              <div className="status-icon success">
                <CheckCircleIcon />
              </div>
            )}
            {isLoading && (
              <div className="status-icon pending">
                <ExclamationCircle />
              </div>
            )}
            <div className="environment-column">
              <p className="environment-branch">
                User
                <div
                  onClick={() => {
                    navigator.clipboard.writeText(user!);
                  }}
                  className="card-icon"
                >
                  <CopyShapeIcon />
                </div>
              </p>
              <span>{user}</span>
            </div>
            <div className="environment-column">
              <p className="environment-branch">
                Password
                <div
                  onClick={() => {
                    navigator.clipboard.writeText(password!);
                  }}
                  className="icon card-icon"
                >
                  <CopyShapeIcon />
                </div>
              </p>
              <span className="environment-content-pass">*************</span>
            </div>
          </div>
          {!envFtpVerified?.verified && !isLoading && (
            <a
              href={`${baseUrl}/installs/${environment}/sftp_users`}
              className="link-button-primary"
            >
              Set Credentials
            </a>
          )}
        </div>
        {envFtpVerified && !envFtpVerified?.verified && !isLoading ? (
          <div className="environment-error-msg">
            Failed to connect. Please reset credentials and try again.
          </div>
        ) : (
          ''
        )}
        {isLoading && <div className="env-pending-msg">Pending</div>}
      </div>
    </div>
  );
}

export default Credential;
